/**
 * 课程筛选结果
 */
export default {
  loadMoreButtonName: 'Load More',
  errorNotice: 'Loading failed, please try again.',
  emptyNotice: 'No courses under this category. Browse courses for other grades/year groups.',
}
